// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgErrorNotFound = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    data-name="Error 404"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="45 110 749 480"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <style>{`
.nf-1 {
  stroke: rgba(0, 0, 0, 0.05);
}

.nf-1,
.nf-2 {
  fill: #fff;
}

.nf-3 {
  fill: #f39ee5;
}

.nf-4 {
  fill: #474747;
}

.nf-5 {
  font-family: Satoshi-Black, Satoshi;
  font-size: 224.18px;
  font-weight: 800;
}

.nf-5,
.nf-6 {
  fill: #ff49a4;
}
`}</style>
    </defs>
    <path
      className="nf-4"
      d="M482.26,122.96c-.81.98-.85,2.9-.59,4.92.08.58.19,1.17.31,1.74.53,2.67,1.37,5.03,1.37,5.03l8.13.77s1.34-2.6,2.38-5.3c.22-.58.43-1.15.6-1.72.51-1.62.78-3.09.45-3.85-1.02-2.27-2.21-3.68-4.58-4.44-2.37-.74-5.94.26-8.07,2.84h0Z"
    />
    <text className="nf-5" transform="translate(505.39 375.63)">
      <tspan x={0} y={0}>
        {"4"}
      </tspan>
    </text>
    <path d="M514.37,220.9s-.72.8-1.89,1.97h0c-.41.42-.87.9-1.38,1.39-2.79,2.72-6.8,6.34-9.86,7.76-5.18,2.4-13.7,3.27-14.07,4.96-.36,1.67,1.75,7.81,4.98,10.82,1.58,1.46,4.1,1.33,6.84.46h0c2.58-1.47,5.97-3.14,10.21-4.96h0c3.15-1.81,6.95-4.16,9.43-5.72.59-.37,1.11-.7,1.53-.96.69-.44,1.11-.7,1.11-.7,0,0-6.91-15.02-6.91-15.02Z" />
    <path d="M517.42,184.94s-7.67,3.85-12.33,7.3l-14.05,10.37c-5.31,3.92-19.44,17.34-21.07,18.54-1.63,1.21-9.5-8.09-7.91-10.72,1.59-2.62,9.14-10.55,16.92-17.38,7.78-6.83,20.47-15.96,20.47-15.96" />
    <path
      className="nf-1"
      d="M522.04,169.03c-6.79,9.12-24.78,21.75-24.78,21.75,0,0,.07.28.2.8.13.48.31,1.16.55,2.03,1.67,5.96,6.06,20.23,12.87,31.84.33.55.66,1.1.99,1.64l.04.06c3.93,6.31,7.48,9.89,10.32,11.89.31.23.61.42.9.61.21.14.42.27.62.38.39.23.74.42,1.09.58,2.43,1.16,3.88,1.02,3.88,1.02,0,0,10.83-4.65,15.63-5.54,4.8-.9,11.4,3.57,16.54,5.79.45-.13.93-.28,1.41-.47.87-.3,1.78-.69,2.71-1.14,3.92-1.92,8.18-5.12,11.21-9.7,4.13-6.27,4.53-10.31,2.99-18.49-1.53-8.18-3.83-24.17-23.69-51.07-5.88-7.96-12.23-13.96-16.2-17.29-.64-.54-1.23-1.01-1.73-1.4-1.35-1.05-2.18-1.58-2.24-1.54-3.65,11.67-6.53,19.14-13.31,28.26Z"
    />
    <text className="nf-5" transform="translate(196.87 375.63)">
      <tspan x={0} y={0}>
        {"4"}
      </tspan>
    </text>
    <path d="M497.47,191.58c5.12,16.57,40.01-8.6,45.96-24.1,4.84-12.63,1.2-18.98-2.73-22.83-3.03-2.97-6.84-5.02-10.93-6.14-24.68-6.73-42.82-8.87-45.52-8.57-3.14.36-6.03,1.08-6.03,1.08-.18.04-.85.21-1.76.47-1.59.46-5.76,1.75-11.02,4.49,0,0-.82.43-1.59.86-11.72,6.53-19.14,16.31-19.14,16.31-9.83,12.95-4.61,19.44-11.83,36.82-.57,1.37-2.53,5.98-.63,8.15.73.83,1.13.28,5.16,2.01,1.55.67,2.82,1.32,4.59,1.18,0,0,.77-.06,1.52-.31,3.37-1.11,4.46-10.15,8.36-15.53,3.3-4.56,9.1-7.17,13.88-7.46,7.36-.45,9.76,4.74,18.26,5.81,6.08.77,11.36-1.06,14.94-2.78" />
    <path
      className="nf-4"
      d="M490.49,144.95l4.71,6.67s9.53-1.74,10.7-4.88c1.17-3.12.28-6.72-1.55-8.42-1.82-1.69-3.64-2.01-6.13-1.77-2.47.24-7.73,8.38-7.73,8.38h0Z"
    />
    <path
      className="nf-3"
      d="M474,171.82c-1.1-.75-1.82-1.43-2.05-2.74s.19-2.19.95-3.29c.77-1.09,2.28-1.95,3.49-2.19,1.21-.25,2.01-.26,3.15.2s2.76,2.03,2.95,3.35c.19,1.32-.19,2.19-.95,3.29-.76,1.1-1.9,1.9-3.49,2.19-1.58.29-2.94-.06-4.04-.81Z"
    />
    <path
      className="nf-2"
      d="M459.95,159.49c-.41-3.79,2.31-7.19,6.1-7.6,3.79-.41,7.19,2.31,7.6,6.1s-2.31,7.19-6.1,7.6c-3.79.41-7.19-2.31-7.6-6.1Z"
    />
    <path d="M460.96,160.16c-.32-2.94,1.8-5.59,4.74-5.92s5.59,1.8,5.92,4.74c.33,2.95-1.8,5.59-4.74,5.92-2.95.33-5.59-1.8-5.92-4.74Z" />
    <circle className="nf-6" cx={423.3} cy={287.69} r={84.61} />
    <path d="M522.6,237.19c-3.09,1.77-5.99,3.88-9.59,5.69l-.62.33c-.52.35-1.02.69-1.5.99-2.72,1.76-5.58,3.5-8.31,4.6-2.69,1.74-4.66,3.33-4.71,4.22-.08,1.92,2.87,8.3,4.29,9.48,1.43,1.19,12.02-1.89,19.23-4.09,7.2-2.21,15.08-4.52,21.67-7.39,4.24-1.85,11.04-5.17,15.34-7.28,1.2-.59,2.21-1.1,2.9-1.45.69-.33,1.08-.53,1.08-.53,0,0-10.25-5.69-15.26-7.07-5.02-1.37-12.39-2.18-18.33-.32-1.6.51-3.07,1.14-4.47,1.87-.58.29-1.16.62-1.72.95h0Z" />
    <path d="M521.78,166.47s-9.29,11.88-20.93,24.3c-11.65,12.42-27.03,29.79-27.03,29.79,0,0-.12,9.62,8.77,9.29,0,0,6.36-3.54,21.87-18.73,10.19-9.98,22.61-23.94,27.9-29.96,1.64-1.87,2.59-2.98,2.59-2.98l.05-.05" />
  </svg>
);
export { SvgErrorNotFound };
